
import Header from "@/components/header/header.vue";
import {mapState,} from 'vuex'
import { ref,inject, shallowRef, reactive } from 'vue'
import { useRoute, useRouter} from "vue-router";
import { Toast } from 'vant'

export default {
// import引入的组件需要注入到对象中才能使用
  components: {
   Header

  },
  setup() {
    const $http: any = inject("$http");
    let $store:any = inject('$store')
   let imgs = shallowRef([])
   let networkInfo:any = shallowRef({})
   let netWorkUrl = ref('')
      const route = useRoute()
    // 物流轨迹  网点
   const getPickupInfo =  async() => {
     await $http.getPickupInfo(route.params.id).then((res:any) => {
        if (res.code === 200) {
          imgs.value = res.data.imgs
          networkInfo.value = res.data.networkInfo
          netWorkUrl.value = `https://google.com/maps/embed/v1/place?key=AIzaSyAHk00cVcMcJsY6zHGOom50OmcBUITNaDQ&q=${networkInfo.value.latitude},${networkInfo.value.longitude}&zoom=16`
        } else {
          Toast({
          message: res.message,
          duration: 3000
        })
        }
      })
     
    }
    getPickupInfo()
    const goMapFn = () => {
      window.open(netWorkUrl.value)   
    }
   return{
     networkInfo,
     imgs, 
     goMapFn
   }
  }
   
 
}
